var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6841 9.9495H8.92568V12.489H11.6841V9.9495Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3865 9.9495H13.6281V12.489H16.3865V9.9495Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0846 9.9495H18.3262V12.489H21.0846V9.9495Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6841 14.3367H8.92568V16.8762H11.6841V14.3367Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3865 14.3367H13.6281V16.8762H16.3865V14.3367Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0846 14.3367H18.3262V16.8762H21.0846V14.3367Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6841 18.7195H8.92568V21.259H11.6841V18.7195Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3865 18.7195H13.6281V21.259H16.3865V18.7195Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0846 18.7195H18.3262V21.259H21.0846V18.7195Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6841 23.1067H8.92568V25.6462H11.6841V23.1067Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3865 23.1067H13.6281V25.6462H16.3865V23.1067Z",
    fill: "#222222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0846 23.1067H18.3262V25.6462H21.0846V23.1067Z",
    fill: "#222222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9978 27.6953H3.11914V29.0088H14.9978V27.6953Z",
    fill: "#222222"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2935 7.6202H4.97997V28.352H6.2935V7.6202Z",
    fill: "#222222"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14385 6.96344H4.97997V8.27696H9.14385V6.96344Z",
    fill: "#222222"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14385 4.48961H7.83032V8.05366H9.14385V4.48961Z",
    fill: "#222222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5739 3.39501H7.83032V4.70854H11.5739V3.39501Z",
    fill: "#222222"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5739 1.00879H10.2603V4.05615H11.5739V1.00879Z",
    fill: "#222222"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9978 1.00879H10.9171V2.32232H14.9978V1.00879Z",
    fill: "#222222"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8808 28.352H15.0022H26.8808Z",
    fill: "#222222"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8808 27.6953H15.0022V29.0088H26.8808V27.6953Z",
    fill: "#222222"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.02 7.6202H23.7065V28.352H25.02V7.6202Z",
    fill: "#222222"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.02 6.96344H20.8561V8.27696H25.02V6.96344Z",
    fill: "#222222"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1697 4.48961H20.8561V8.05366H22.1697V4.48961Z",
    fill: "#222222"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1697 3.39501H18.4261V4.70854H22.1697V3.39501Z",
    fill: "#222222"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7396 1.00879H18.4261V4.05615H19.7396V1.00879Z",
    fill: "#222222"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0829 1.00879H14.5249V2.32232H19.0829V1.00879Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.c883a15396d002e7fe45332370261fd7.svg";
export { ForwardRef as ReactComponent };